import { gamePrizeUploadKey } from '../../keys'
import { useQueryClient } from '@tanstack/react-query'
import { type GamePrizeUploadSuccess, type GameId, type PrizeId } from '@terros/common'

type PrizeCache = {
  clearItem: (gameId: GameId, prizeId?: PrizeId) => void
  updateImage: (gameId: GameId, prizeId?: PrizeId) => void
}

export function usePrizeCache(): PrizeCache {
  const queryClient = useQueryClient()
  return {
    clearItem: (gameId: GameId, prizeId?: PrizeId) => {
      queryClient.invalidateQueries({ queryKey: gamePrizeUploadKey(gameId, prizeId) })
    },
    updateImage: (gameId: GameId, prizeId?: PrizeId) => {
      queryClient.setQueryData(gamePrizeUploadKey(gameId, prizeId), (prev: GamePrizeUploadSuccess | undefined) => {
        if (!prev) return
        return {
          ...prev,
          download: prev.download + '?v=' + Date.now(),
        }
      })
    },
  }
}
